import React from "react";
import { Container, Paper, Typography } from "@mui/material";
import NotificationView from "./NotificationComponent/NotificationView";

const NotificationContainer = () => {
  return (
    // <Container style={{ marginTop: "20px", maxWidth:"100% !important" }}>
      <Paper elevation={3} style={{ margin: "5px",padding: "20px" }}>
        <Typography variant="h5" align="left" gutterBottom>
          Email Preview Management
        </Typography>
        <NotificationView />
      </Paper>
    // </Container>
  );
};

export default NotificationContainer;
